import React from 'react'
import { IoDiamond } from 'react-icons/io5'
import moment from 'moment'
import _ from 'lodash'
import classNames from 'classnames'
import { Button } from 'react-bootstrap'

import { CURRENCY } from '../../../../../helpers/constants'
import { RENEWAL_UNITS } from '../../../../../helpers/constants'

const SubscriptionDetails = ({ plan }) => {

  const formatDate = (date) =>
    moment(date).format('DD MMM YYYY')
  const renewalUnit = Object.values(RENEWAL_UNITS).find((unit) =>
    unit.patterns.some(
      (pattern) =>
        pattern.unit === plan.product_renewal.unit &&
        pattern.count === plan.product_renewal.count
    )
  )

  const billingLabel = renewalUnit ? renewalUnit.name.toLowerCase() : plan.product_renewal.unit

  return (
    <div className="subscription-card">
      <div className="subscription-card__icon">
        <IoDiamond size={18} />
      </div>
      <div className="subscription-card__content">
        <div className="subscription-card__header">
          <h2 className="subscription-card__title">
            {plan.product_name}
          </h2>
          <button
            className="subscription-card__link-button"
            disabled={true}
          >
            What&apos;s Included?
          </button>
        </div>
        <div
          className={classNames(
            'subscription-card__description',
            {
              'subscription-card__description--cancelled': plan.status === 'cancelled',
              'subscription-card__description--active': plan.status === 'active'
            }
          )}
        >
          {
            plan.status === 'cancelled'
              ? `You have cancelled this plan, it will expire on ${formatDate(plan.end_time)}`
              : `You are on a ${billingLabel} plan and your next charge will be on ${formatDate(plan.end_time)}`
          }
        </div>
        <div className="subscription-card__info-row">
          <span>Credits</span>
          <span>
            {plan.credits.toLocaleString()} per {plan.credits_renewal.unit}
          </span>
        </div>
        <div className="subscription-card__info-row">
          <span>Price</span>
          <span>
            {CURRENCY[plan.price.currency?.toUpperCase()]?.symbol || ''}
            {plan.price.total_price.toLocaleString()} per {plan.product_renewal.unit}
          </span>
        </div>
        <div className="subscription-card__info-row">
          <span>Status</span>
          <span
            className={classNames(
              'subscription-card__status',
              {
                'subscription-card__status--active': plan.status === 'active',
                'subscription-card__status--cancelled': plan.status === 'cancelled'
              }
            )}
          >
            {_.startCase(plan.status)}
          </span>
        </div>
        <div className="subscription-card__info-row">
          <span>Next Credit Allocation</span>
          <span>
            {moment(plan.credits_renewal_date).fromNow()}, {formatDate(plan.credits_renewal_date)}
          </span>
        </div>
        <div className="subscription-card__footer">
          <Button
            className="subscription-card__primary-button subscription-card__primary-button--disabled"
            variant="outline-primary"
            disabled={true}
          >
            Upgrade
          </Button>

        </div>

      </div>

    </div>
  )
}

export default SubscriptionDetails